import { articulosSelector } from "features/Inventario/redux/selectors/articulosSelectors"
import { getCatalogoSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import {
  clearArticuloState,
  getArticulosGroupedByCategoria,
} from "features/Inventario/redux/slices/articulosSlice"
import {
  clearCatalogosState,
  getCatalogo,
} from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect } from "react"
import { useParams } from "react-router-dom"
import ViewCatalogo from "./ViewCatalogo"

const ViewCatalogoContainer = () => {
  const { catalogo, categorias } = useSelector(getCatalogoSelector)
  const { searchArticuloName, articulosGroupedByCategoria, fetchingArticulos } =
    useSelector(articulosSelector)

  const params = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearArticuloState())
    dispatch(clearCatalogosState())
  }, [dispatch])

  useEffect(() => {
    dispatch(getCatalogo(params.id))
  }, [dispatch, params])

  const filterArticulos = useCallback(
    (filters: $TSMigrationFixMe) => {
      dispatch(
        getArticulosGroupedByCategoria({ catalogoId: params.id, ...filters })
      )
    },
    [dispatch, params]
  )

  return (
    <ViewCatalogo
      articulosGroupedByCategoria={articulosGroupedByCategoria}
      categorias={categorias}
      filterArticulos={filterArticulos}
      searchArticuloName={searchArticuloName}
      fetchingArticulos={fetchingArticulos}
      catalogo={catalogo}
    />
  )
}

export default ViewCatalogoContainer
